


import React from "react";
import { Helmet } from 'react-helmet';
import usePageBackground from "../hooks/usePageBackground";
import { useFadeInOnScroll } from "../theme/global";
import { Box, Typography, Container } from "@mui/material";
import { motion } from "framer-motion";
import "../css/global.css";
import FadeSection from "../components/fadeSection"; 
import FadeItem from "../components/fadeItem";
import { text1, text2, text3, text4} from "../components/cookiesText";



const PoliticaCookies = () => {
  const subtituloStyle = {
    fontFamily: "Nunito, sans-serif",
    fontWeight: 400,
    color: "rgb(99, 92, 24)",
    mb: 4,
    textAlign: "left",
    fontSize: "32px",
    alignSelf: "flex-start",
  };

  usePageBackground('legal-background-color');
  const containerRef = useFadeInOnScroll();

  const textoStyle = {
    fontFamily: "Nunito, sans-serif",
    fontWeight: 400,
    fontSize: "1rem",
    textAlign: "justify",
    color: "rgb(99, 92, 24)",
    mb: 2,
  };


  return (
    <>
    <Helmet>
      <title>Política de Cookies | CES</title>
      <meta name="description" content="Información sobre el uso de cookies." />
    </Helmet>
    <Box
      ref={containerRef}
      className="legal-container fade-up"
      sx={{
        textAlign: "center",
        px: { xs: "1em", md: "8em" },
        py: { xs: "1em", md: "4em" },
        my: 2,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        overflow: "hidden",
        width: "100%",
      }}
    >
     <FadeItem
      text="Política de cookies"
      style={{
        fontFamily: "Raleway, sans-serif",
        fontWeight: 400,
        color: "#66ab5ecf",
        mb: 4,
        textAlign: "center",
        paddingTop: 2
      }}
      variant="h2"
    />

      <FadeItem
          text="Política de cookies"
          style={subtituloStyle}
          variant="body1"
        />
      <FadeSection texts={text1} style={textoStyle} />

      <FadeItem
        variant="body1"
          text="¿Qué son las cookies?"
          style={subtituloStyle}
        />
      <FadeSection texts={text2} style={textoStyle} />

      <FadeItem    
      text="Tipos de cookies"
      style={subtituloStyle}
       variant="body1"
      />
      <FadeSection texts={text3} style={textoStyle} />

      <FadeItem    
      text="Desactivación y eliminación de cookies"
      style={subtituloStyle}
       variant="body1"
      />
      <FadeSection texts={text4} style={textoStyle} />

      
    </Box>
    </>
  );
};

export default PoliticaCookies;